<script>
import { mapState } from 'vuex';

export default {
    name: "studyAll",
    data() {
        return {};
    },
    computed: {
        ...mapState(['studyMenu']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="studyAll" v-if="studyMenu.length > 0">
        <div class="list1 flex">
            <div class="item" v-for="(item, index) in studyMenu[0].children" :key="index" v-if="index <= 1">
                <div class="cover">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <div class="name text_shadow">{{ item.name }}</div>
                    <div class="desc text_shadow only_pc">{{ item.desc }}</div>
                </div>
                <div class="desc only_mobile">{{ item.desc }}</div>
                <div class="flex justify_end">
                    <router-link class="btn layout_flex_center" :to="`/study/list?id=${item.id}`">{{ item.button_name }}</router-link>
                </div>
            </div>
        </div>
        <div class="list2 flex flex_wrap">
            <router-link class="item" v-for="(item, index) in studyMenu[0].children" :key="index" v-if="index > 1" :to="`/study/list?id=${item.id}`">
                <div class="cover">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <div class="name text_shadow">{{ item.name }}</div>
                </div>
                <div class="desc">{{ item.desc }}</div>
            </router-link>
        </div>
    </div>
</template>

<style scoped lang="scss">
.studyAll{
    .list1{
        gap: .5rem;
        margin-bottom: .4rem;
        @media only screen and (max-width: 750px) {
            flex-direction: column;
        }
        .item{
            flex: 1;
            .cover{
                position: relative;
                margin-bottom: .25rem;
                color: #fff;
                .bg{
                    height: 0;
                    padding-bottom: 62.62%;
                    // 
                    // border: 1px solid #000;
                    @media only screen and (max-width: 750px) {
                        padding-bottom: 76.81%;
                    }
                }
                .name{
                    font-size: .22rem;
                    position: absolute;
                    top: .25rem;
                    left: .25rem;
                    @media only screen and (max-width: 750px) {
                        font-size: .25rem;
                    }
                }
                .desc{
                    font-size: .2rem;
                    position: absolute;
                    bottom: .25rem;
                    left: .25rem;
                    right: .25rem;
                    @media only screen and (max-width: 750px) {
                        font-size: .28rem;
                    }
                }
            }
            .btn{
                border: 1px solid #666;
                font-size: .18rem;
                color: #666;
                height: .45rem;
                padding: 0 .3rem;
                cursor: pointer;
                @media only screen and (max-width: 750px) {
                    height: .64rem;
                    font-size: .26rem;
                    margin: .3rem auto 0;
                }
            }
        }
    }
    .list2{
        gap: .5rem;
        @media only screen and (max-width: 750px) {
            flex-direction: column;
        }
        .item{
            width: 3.4rem;
            @media only screen and (max-width: 750px) {
                width: 100%;
            }
            .cover{
                position: relative;
                margin-bottom: .25rem;
                .bg{
                    padding-bottom: 100%;
                    @media only screen and (max-width: 750px) {
                        padding-bottom: 76.81%;
                    }
                    // 
                    // border: 1px solid #000;
                }
                .name{
                    font-size: .22rem;
                    position: absolute;
                    top: .25rem;
                    left: .25rem;
                    color: #fff;
                    @media only screen and (max-width: 750px) {
                        font-size: .25rem;
                    }
                }
            }
            .desc{
                font-size: .18rem;
                @media only screen and (max-width: 750px) {
                    font-size: .28rem;
                }
            }
        }
    }
}
</style>